/**
 * Veeam Service Provider Console REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Indexing mode.
 */
export enum BackupServerBackupJobGuestFSIndexingMode {
    Disable = 'disable',
    IndexAll = 'indexAll',
    IndexAllExcept = 'indexAllExcept',
    IndexOnly = 'indexOnly'
};

